const SNOW_PLOW_SCRIPT_URL = "/shared/sp.js";

const initSnowPlowScript = (onLoad = () => {}) =>
  (function (p, l, o, w, i, n, g) {
    if (!p[i]) {
      p.GlobalSnowplowNamespace = p.GlobalSnowplowNamespace || [];
      p.GlobalSnowplowNamespace.push(i);
      p[i] = function () {
        (p[i].q = p[i].q || []).push(arguments);
      };

      p[i].q = p[i].q || [];
      n = l.createElement(o);
      g = l.getElementsByTagName(o)[0];
      n.async = 1;
      n.src = w;
      g.parentNode.insertBefore(n, g);

      n.onload = onLoad;
    }
  })(window, document, "script", SNOW_PLOW_SCRIPT_URL, "snowplow");

module.exports = initSnowPlowScript;
